/**
 * A counter-offer for time-negotiation.  The only required field is proposedDate, but the API endpoint used may provide two other values.
 *
 * I understand that all fields below shall be required when one of these is returned to the API.
 */
export interface CounterOffer {
  /**
   * An identifier for a counter-offer
   */
  counterOfferId: number;

  /**
   * A proposed new delivery time.  The value comes from the API as an ISO 8601
   * Extended Datetime string, e.g. "2018-11-12T10:09:31".  Time-zone information
   * is not expected from this API endpoint.
   *
   * The other two times are optional and use the same format.  They relate to
   * another use of the API, and are only here because they might be required
   * for a PATCH operation.
   */
  proposedDate: string;
  proposedTimeFrom?: string;
  proposedTimeTo?: string;

  /**
   * Whether this counter-offer has been selected by the user
   */
  accepted: boolean;
}
